import Vue from 'vue'
import { hostsConfig } from 'init/config'
import domUtils from 'util/dom-utils'
import globalConfig from 'init/global.config'
import globalStore from 'init/global-store'
import { ssoCreateReview, ssoGetLoggedInDataForReview } from 'services/sso-service'
import reviewsListConfig from 'widgets/reviews-list/reviews-list-widget.config'
import reviewsStore from 'store/reviews-store'
import submissionLoader from 'widgets/submission/submission-loader'
import submissionStore, { Source } from 'store/submission-store'
import FilterList from 'objects/menu/filter-list'
import Menu from 'objects/menu/menu'
import MenuList from 'objects/menu/menu-list'
import SearchField from 'objects/form/search-field'
import { SortOption } from 'services/api-service'

import withRender from './reviews-list-toolbar.html'
import './reviews-list-toolbar.scss'

export default withRender(Vue.extend({
  data() {
    return {
      filterMenuLeftPos: 0,
      reviewsStore,
      submissionStore,
      showSearchField: false,
      store: globalStore
    }
  },
  components: {
    'tt-filter-list': FilterList,
    'tt-menu': Menu,
    'tt-menu-list': MenuList,
    'tt-search-field': SearchField
  },
  computed: {
    hideWriteReview() {
      return reviewsListConfig.hideWriteReview
    },
    filterStore() {
      return this.reviewsStore.filterStore
    },
    filters() {
      return reviewsListConfig.filters
    },
    filtersLabel() {
      const numberOfFilterOptionsApplied = this.reviewsStore.filterStore.filtersFlattened.length
      return numberOfFilterOptionsApplied === 0 ? this.$msg('reviewsList.filter.none') :
        this.$msg('reviewsList.filter', [numberOfFilterOptionsApplied])
    },
    isLaunchingWriteReview() {
      return submissionStore.isLaunchingWriteReview
    },
    sortBy() {
      return this.reviewsStore.sort
    },
    sortByTitle() {
      return this.$msg(`reviewsList.sortBy.${this.sortBy}`)
    },
    sortOptions() {
      return reviewsListConfig.sortOptions.map((option) => {
        return { name: option, title: this.$msg(`reviewsList.sortBy.${option}`) } as SortOption
      })
    }
  },
  methods: {
    closeSearch() {
      this.$refs.searchFieldComponent.clearText()
      this.showSearchField = false
      this.$emit('toggleSearch', false)
      this.$nextTick(() => this.$refs.openSearchTrigger.$el.focus())
    },
    openSearch() {
      this.showSearchField = true
      domUtils.safeFocusRef(this.$refs.searchFieldComponent.$refs, 'field')
      this.$emit('toggleSearch', true)
    },
    sortOrderSelected(sort: SortOption) {
      this.reviewsStore.sort = sort.name
    },
    updateSearchText(value) {
      this.reviewsStore.searchTerm = value
    },
    writeReview(e) {
      // if sso, this will be set back to false when ssoRegDone or loggedInDataFnDone is called
      submissionStore.isLaunchingWriteReview = true
      if (globalConfig.ssoEnabled) {
        if (globalConfig.isPurchaseReq()) {
          ssoCreateReview(this.store.sku, Source.INLINE)
        } else {
          ssoGetLoggedInDataForReview(this.store.sku, Source.INLINE)
        }
        return
      }
      submissionStore.startRevFlow(
        this.store.sku,
        hostsConfig.siteKey,
        { page: 'review-form', props: {} },
        { startAction: 'review', source: Source.INLINE },
        e.currentTarget
      )
      submissionLoader.load()
      submissionStore.isLaunchingWriteReview = false
    }
  },
  mounted() {
    // for mobile-ish, going to align the menu with the left side of the toolbar so it is better
    // positioned
    domUtils.whenRefIsVisible(this.$refs, 'filterMenu').then(() => {
      if (this.$el.offsetWidth <= 360) {
        this.filterMenuLeftPos = -(this.$refs.filterMenu.$el.offsetLeft)
      }
    })
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/reviews-list/reviews-list-toolbar.ts